
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, profile, loading, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      // Not authenticated, redirect to admin login
      navigate('/admin/login', { 
        state: { from: location.pathname },
        replace: true 
      });
      return;
    }

    if (!isAdmin) {
      // Authenticated but not an admin
      navigate('/admin/login', { 
        state: { error: 'Access denied. Admin privileges required.' },
        replace: true 
      });
      return;
    }
  }, [user, profile, loading, isAdmin, navigate, location]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return null;
  }

  return <>{children}</>;
}
